import { render, staticRenderFns } from "./MessageFormModal.vue?vue&type=template&id=0fd28ac0"
import script from "./MessageFormModal.vue?vue&type=script&lang=js"
export * from "./MessageFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports